import { render, staticRenderFns } from "./OaoFormAddressInput.vue?vue&type=template&id=38605498&scoped=true"
import script from "./OaoFormAddressInput.vue?vue&type=script&lang=js"
export * from "./OaoFormAddressInput.vue?vue&type=script&lang=js"
import style0 from "./OaoFormAddressInput.vue?vue&type=style&index=0&id=38605498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38605498",
  null
  
)

export default component.exports